<template>
  <div class="w-full h-full absolute inset-0"
       data-grm-comp="GrmDraggableResizable"
  >
    <vue-draggable-resizable :w="w" :h="h" 
                             :x="x" :y="y" :z="z"
                             :min-width="minWidth" :max-width="maxWidth" 
                             :min-height="minHeight" :max-height="maxHeight" 
                             :lockAspectRatio="lockAspectRatio" 
                             :parent="parent"
                             :onResize="onResize" :onDrag="onDrag"
                             class="top-0 left-0"
                             style="pointer-events: auto"
    >
      <slot></slot>
    </vue-draggable-resizable>
  </div>
</template>

<script>
export default {
  name: 'GrmDraggableResizable',
  props: {
    w: { type: [Number, String] },
    h: { type: [Number, String] },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    z: { type: [Number, String], default: 'auto' },
    parent: { type: Boolean, default: false },
    minWidth: { type: Number, default: 1 },
    minHeight: { type: Number, default: 1 },
    maxWidth: { type: Number, default: 1920 },
    maxHeight: { type: Number, default: 1080 },
    lockAspectRatio: { type: Boolean, default: false },
    onResize: {type: Function, default: ()=>{}},
    onDrag: {type: Function, default: ()=>{}},
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .handle {
    pointer-events: auto !important;
  }
}
</style>